import React from 'react';
import "../HeadLine/headLine.css"
import IconButton from "@mui/material/IconButton";
import SyncIcon from '@mui/icons-material/Sync';
import {useNavigate} from "react-router-dom";
const HeadLine = (props) => {
    const history = useNavigate()
    return (
        <div className={"headline"}>
            <div className={"headline-title"}>
                <a href={props.link}>{props.title}</a>
                <div>{props.subTitle}</div>
            </div>
            <div onClick={() => {history(-1)}} className={"headline-icon"}>
                <img src="https://img.icons8.com/material-rounded/24/000000/near-me.png"/>
            </div>
        </div>
    );
};

export default HeadLine;